import {useEffect} from "react";
import {useRecoilState} from "recoil";
import {userState} from "../../states/common";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import {clearAnalyticsUser, trackEvent} from "../../helpers/analytics";
import {quenThietBiKhiDangXuat} from "../../helpers/push";

const LogoutPage = () => {
 const [user, setUser] = useRecoilState(userState)
 const navigate = useNavigate()
 useEffect(() => {
  const chay = async () => {
  /* Bỏ đăng ký thiết bị phải XONG TRƯỚC khi xoá token đăng nhập, vì chính lời
     gọi huỷ cần token đó để đi qua xác thực. Gọi mà không chờ thì nó chỉ kịp
     đọc token nhờ đúng thứ tự microtask - ai thêm một await vào giữa chuỗi đó
     là hỏng, mà hỏng thì im lặng.

     Chờ tối đa 2 giây: mạng treo không được giữ người dùng lại ở màn đăng xuất.
     Quá hạn thì thiết bị vẫn còn đăng ký ở server, nhưng người sau đăng nhập và
     bật thông báo sẽ đổi chủ token đó. */
  await Promise.race([
   quenThietBiKhiDangXuat(),
   new Promise((xong) => setTimeout(xong, 2000)),
  ])
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
  setUser({
   email: "",
   id: "",
   isCalibrated: false,
   isExpert: false,
   isVerified: false,
   name: "",
   phone: "",
   profilePicture: "",
   ranking: {code: "--", class: "--"},
   score: 0,
   leagues: [],
   roles:{isExpert:false, isReferee:false}
  })
  trackEvent('logout')
  clearAnalyticsUser()
  toast('Đăng xuất tài khoản thành công')
  // Về trang chủ chứ không phải màn đăng nhập: trang chủ xem được khi chưa đăng
  // nhập, và ở đó đã có nút Đăng nhập góc trên bên phải.
  navigate('/', {replace: true})
  }
  chay()
 },[])
  return <></>
}

 export default LogoutPage